import { push, getRouteParams } from "yarrr";
import { useDispatch, useSelector } from "react-redux";

export const useNavigation = () => {
	const dispatch = useDispatch();

	return {
		navigate: (path) => dispatch(push(path)),
	};
};

export const useParams = () => {
	const params = useSelector(getRouteParams);
	return params;
};
